export default {
  id: 'docsProcedures',
  label: 'Docs & Procedures',
  stores: {},
  globalComponents: {},
  routes: ['DocsProcedures'],
  nav: [{ label: 'Docs & Procedures', routeName: 'DocsProcedures', group: 'more' }],
}
